{
  "name": "@ns/lambda-error-debug",
  "version": "1.0.0",
  "description": "This job is for developers to debug lambda errors",
  "inputs": {
    "error": {
      "type": "string"
    },
    "eventId": {
      "type": "string",
      "optional": true
    },
    "eventType": {
      "type": "string",
      "optional": true
    },
    "eventObject": {
      "type": "string",
      "optional": true
    }
  },
  "outcomes": {
    "complete": {}
  }
}
